<template>
    <form @submit.prevent="submit" @keydown="errors.clear($event.target.name)">

        <base-input class="mb-3"
            :label="$t('users.firstname')"
            :placeholder="$t('users.firstname')"
            required
            v-model="value.firstname"
            name="firstname"
            :error="errors.get('firstname')">
        </base-input>

        <base-input class="mb-3"
            :label="$t('users.lastname')"
            :placeholder="$t('users.lastname')"
            required
            v-model="value.lastname"
            name="lastname"
            :error="errors.get('lastname')">
        </base-input>

        <base-input class="mb-3"
            type="email"
            :label="$t('common.email')"
            :placeholder="$t('common.email')"
            required
            v-model="value.email"
            name="email"
            :error="errors.get('email')">
        </base-input>

        <base-input class="mb-3"
            type="password"
            :label="$t('common.password')"
            :placeholder="$t('common.password')"
            v-model="value.password"
            name="password"
            :error="errors.get('password')">
        </base-input>

        <base-select class="mb-4" v-if="Object.keys(roles).length > 0 && !(value.id && !value.role_id && $auth.user.id === value.id)"
            :label="$t('common.role')"
            :placeholder="$t('common.role')"
            v-model="value.role_id"
            :options="roles"
            :disabled="$auth.user.id === value.id"
            clearable>
        </base-select>

        <base-select class="mb-3" v-if="Object.keys(entities).length > 0 && !(value.id && !value.entity_id && ($auth.user.id === value.id || $auth.user.entity_id))"
            :label="$t('common.entity')"
            :placeholder="$t('common.entity')"
            v-model="value.entity_id"
            :options="entities"
            :disabled="$auth.user.entity_id !== null || $auth.user.id === value.id"
            clearable>
        </base-select>

        <base-checkbox class="mb-4" v-model="value.active" v-if="$auth.user.id !== value.id">
            {{ $t('common.active') }}
        </base-checkbox>

        <div class="category form-category mb-3">* {{ $t('common.required-fields') }}</div>

        <div class="buttons pt-2 text-center">
            <base-button type="primary" native-type="submit" :disabled="errors.any()">
                {{ value.id ? $t('common.update') : $t('common.create') }}
            </base-button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                {{ $t('common.cancel') }}
            </button>
        </div>

    </form>
</template>

<script>
    export default {

        props: ['value', 'errors', 'roles', 'entities'],

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
